export const TITLE_SIZES = [1, 2, 3, 4, 5, 6] as const;

export const TITLE_DEFAULT_SIZE: (typeof TITLE_SIZES)[number] = 2 as const;
